import ChipTaskCheckStatus from '@/components/chip/ChipTaskCheckStatus';
import type { StatusChipProps } from '@/components/chip/ChipTicketStatus';
import { StatusTaskCheckEnum } from '@/types/enums/status-task-check.enum';

export const getTaskStatusData = (props: StatusChipProps) => {
    return ChipTaskCheckStatus(props);
};

export const getTaskOptionsFilter = () => {
    const enumValues = StatusTaskCheckEnum;

    const options: any[] = [];

    Object.keys(enumValues).forEach(key => {
        const data = getTaskStatusData({
            status: enumValues[key],
            showChip: false,
        });

        options.push({
            id: enumValues[key],
            value: enumValues[key].toUpperCase(),
            title: data.label,
            label: data.label,
        });
    });

    return options;
};
